/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActivityDataModel {
  /** @format int32 */
  contentId: number
  sessionTitle: string
  actionUser: string
  /**
   *
   *
   * 0 = VideoExported
   *
   * 1 = StartCall
   *
   * 2 = SessionCreated
   *
   * 3 = EnterSession
   *
   * 4 = AddAnnotation
   *
   * 5 = SessionDeleted
   *
   * 6 = SessionOwnerChanged
   *
   * 7 = ImageUploaded
   *
   * 8 = VideoUploaded
   *
   * 9 = FormStatusUpdated
   *
   * 10 = EndOfCall
   *
   * 11 = ExportPdf
   *
   * 12 = ExportImages
   *
   * 13 = InvitationSent
   *
   * 14 = InvitationAccepted
   *
   * 15 = SessionPublished
   *
   * 16 = SessionUnpublished
   *
   * 17 = SessionShared
   *
   * 18 = SessionSharingRevoked
   *
   * 19 = SessionCopied
   *
   * 20 = FormStatusUpdatedByAI
   *
   * 21 = SessionReadyForReview
   *
   * 22 = SessionReviewAccepted
   *
   * 23 = SessionFeedbackSent
   *
   * 24 = SessionReviewCompleted
   *
   * 25 = CheckIn
   *
   * 26 = CheckOut
   *
   * 27 = Confirm
   *
   * 28 = SessionReviewRevoked
   *
   * 29 = SessionReviewRejected
   *
   * 30 = SessionSharingRejected
   *
   * 31 = ReviewedSessionCopied
   *
   * 32 = SessionRestored
   *
   * 33 = ContentReactivated
   *
   * 34 = AttachedFormToContent
   *
   * 35 = DetachedFormFromContent
   *
   * 36 = ContentReadyForInContentReview
   *
   * 37 = InContentReviewAccepted
   *
   * 38 = InContentReviewFeedbackSent
   *
   * 39 = InContentReviewCompleted
   *
   * 40 = PageDeleted
   *
   * 41 = PageDeletedPermanently
   *
   * 42 = PageRestored
   *
   * 43 = AnswerDeleted
   *
   * 44 = ThreeHundredSixtyViewCreated
   *
   * 45 = ThreeDeeModelCreated
   *
   * 46 = PointCloudCreated
   *
   * 47 = CADCreated
   *
   * 48 = PageCreated
   *
   * 49 = PageAccessed
   *
   * 50 = TrainingMaterialsAccessed
   *
   * 51 = AnnotationUpdated
   *
   * 52 = AnnotationDeleted
   */
  actionType: UserEventType
  /** @format date-time */
  actionTime?: string | null
}

export interface AllSessionsPageResponse {
  /** @format int32 */
  tenantId: number
  /** @format int32 */
  contentId: number
  title: string
  owner: string[]
  fullUserName: string
  genericId: string
  createdOn: string
  lastActivity: string
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = Live
   *
   * 2 = InProgress
   *
   * 3 = Published
   *
   * 4 = Shared
   *
   * 5 = CallEnded
   *
   * 6 = CheckedIn
   *
   * 7 = CheckedOut
   *
   * 8 = CopiedReview
   */
  sessionStatus: SessionStatus
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = ReadyForReview
   *
   * 2 = InReview
   *
   * 3 = SessionFeedbackSent
   *
   * 4 = Complete
   */
  reviewStatus: ReviewStatus
  /** @format int32 */
  total?: number | null
  /** @format double */
  completedPercent: number
  /** @format double */
  approvedPercent: number
  /** @format double */
  rejectedPercent: number
  /** @format double */
  pendingPercent: number
  /** @format int32 */
  approved: number
  /** @format int32 */
  rejected: number
  /** @format int32 */
  approvedByReviewer: number
  /** @format int32 */
  rejectedByReviewer: number
  /** @format int32 */
  approvedByAI: number
  /** @format int32 */
  rejectedByAI: number
  /** @format int32 */
  pending: number
  /** @format int32 */
  noAction: number
  /** @format int32 */
  pages: number
  /** @format int32 */
  videos: number
  /** @format int32 */
  images: number
  length: string
  /** @format int32 */
  daysActive: number
  nameDetails: SessionNamingConventionAnswerModel[]
  sentFromTenant: string
  reviewFromTenant: string
  reviewToTenant: string
  reviewer: string
  sessionDetails: string[]
  copyOfId: string
  /** @format int32 */
  totalSessionsCount: number
  hasReview: boolean
}

export interface AllSessionsReportModel {
  /** @format int32 */
  tenantId: number
  /** @format int32 */
  contentId: number
  title: string
  owner: string
  fullUserName: string
  genericId: string
  createdOn: string
  lastActivity: string
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = Live
   *
   * 2 = InProgress
   *
   * 3 = Published
   *
   * 4 = Shared
   *
   * 5 = CallEnded
   *
   * 6 = CheckedIn
   *
   * 7 = CheckedOut
   *
   * 8 = CopiedReview
   */
  sessionStatus: SessionStatus
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = ReadyForReview
   *
   * 2 = InReview
   *
   * 3 = SessionFeedbackSent
   *
   * 4 = Complete
   */
  reviewStatus: ReviewStatus
  /** @format int32 */
  total?: number | null
  /** @format double */
  completedPercent: number
  /** @format double */
  approvedPercent: number
  /** @format double */
  rejectedPercent: number
  /** @format double */
  pendingPercent: number
  /** @format int32 */
  approved: number
  /** @format int32 */
  rejected: number
  /** @format int32 */
  approvedByReviewer: number
  /** @format int32 */
  rejectedByReviewer: number
  /** @format int32 */
  approvedByAI: number
  /** @format int32 */
  rejectedByAI: number
  /** @format int32 */
  pending: number
  /** @format int32 */
  noAction: number
  /** @format int32 */
  pages: number
  /** @format int32 */
  videos: number
  /** @format int32 */
  images: number
  length: string
  /** @format int32 */
  daysActive: number
  nameDetails: SessionNamingConventionAnswerModel[]
  sentFromTenant: string
  reviewFromTenant: string
  reviewToTenant: string
  reviewer: string
  sessionDetails: TenantContentDescriptionModel[]
  copyOfId: string
  /** @format int32 */
  totalSessionsCount: number
  hasReview: boolean
}

export interface ApiErrorResponse {
  error: Error
}

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Video
 *
 * 2 = Text
 *
 * 3 = Pdf
 *
 * 4 = VideoByUrl
 *
 * 5 = CloudFile
 *
 * 6 = RecordedVideo
 *
 * 7 = Audio
 *
 * 8 = DrawingBoard
 *
 * 9 = Snapshot
 *
 * 10 = Image
 *
 * 11 = ConcatenatedVideo
 *
 * 12 = WebPage
 *
 * 13 = SpatialModel
 *
 * 14 = DocDocumentPage
 *
 * 15 = PptDocumentPage
 *
 * 16 = ExcelDocumentPage
 *
 * 17 = File
 *
 * 18 = StructureModel
 *
 * 19 = StructureModelPdf
 *
 * 20 = TwoDLineDrawing
 *
 * 21 = TwoDLineDrawingPdf
 *
 * 22 = AutodeskFile
 *
 * 23 = PointCloud
 *
 * 24 = BentleyAnalyticsReportPdf
 *
 * 101 = UnencodedVideo
 *
 * 102 = UnencodedRecordedVideo
 *
 * 103 = UnencodedConcatenatedVideo
 *
 * 104 = RecordedCloudFileVideo
 *
 * 105 = StreamVideo
 * @format int32
 */
export enum ContentType {
  Unknown = 0,
  Video = 1,
  Text = 2,
  Pdf = 3,
  VideoByUrl = 4,
  CloudFile = 5,
  RecordedVideo = 6,
  Audio = 7,
  DrawingBoard = 8,
  Snapshot = 9,
  Image = 10,
  ConcatenatedVideo = 11,
  WebPage = 12,
  SpatialModel = 13,
  DocDocumentPage = 14,
  PptDocumentPage = 15,
  ExcelDocumentPage = 16,
  File = 17,
  StructureModel = 18,
  StructureModelPdf = 19,
  TwoDLineDrawing = 20,
  TwoDLineDrawingPdf = 21,
  AutodeskFile = 22,
  PointCloud = 23,
  BentleyAnalyticsReportPdf = 24,
  UnencodedVideo = 101,
  UnencodedRecordedVideo = 102,
  UnencodedConcatenatedVideo = 103,
  RecordedCloudFileVideo = 104,
  StreamVideo = 105,
}

export interface CreatePowerBIReportRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string
  /** @format uuid */
  powerBIWorkspaceId: string
  /** @format uuid */
  powerBIDashboardId: string
  /** @format int32 */
  reportingProviderId: number
  /**
   *
   *
   * 1 = None
   *
   * 2 = Tenant
   *
   * 3 = UserProfile
   *
   * 4 = UserIdentity
   */
  securityModel: SecurityModelEnum
}

export interface CreatePowerBIReportingProviderRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string
  /** @format uuid */
  azureTenantId: string
  /** @format uuid */
  azureClientId: string
  /**
   * @minLength 1
   * @maxLength 100
   */
  azureClientSecret: string
}

export interface CreateReportDependentModuleRequest {
  /** @format int32 */
  reportId: number
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string
  /** @format uuid */
  externalId: string
}

export interface CreateReportTenantRequest {
  /** @format int32 */
  reportId: number
  /** @format int32 */
  tenantId: number
  /** @minItems 1 */
  securityModels: SecurityModelEnum[]
  /** @minItems 1 */
  tenantRoles: string[]
}

export interface CreateReportUserRequest {
  /** @format int32 */
  reportId: number
  /** @format uuid */
  userIdentityId: string
  /** @format int32 */
  tenantId?: number | null
  /** @minItems 1 */
  securityModels: SecurityModelEnum[]
  /**
   *
   *
   * 1 = Profile
   *
   * 2 = Identity
   */
  accessType: ReportUserAccessType
}

export interface CreateReportsBySubdomainRequest {
  /** @minLength 1 */
  subdomain: string
  origins: ReportTypes[]
  consumers: GeneratedReportReceiverType[]
  mailto?: string[] | null
  /** @uniqueItems true */
  outputFileOptions?: GeneratedReportOutputFileOption[] | null
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
}

export interface CreateTenantContentsDashboardColumnRequest {
  /** @minLength 1 */
  name: string
  /** @format int32 */
  order: number
  isCustom: boolean
}

export interface CreateTenantContentsDashboardRequest {
  /**
   * @minLength 1
   * @maxLength 256
   */
  name: string
  /** @minItems 1 */
  columns: CreateTenantContentsDashboardColumnRequest[]
}

export interface Error {
  /** @format int32 */
  code: number
  /** @minLength 1 */
  message: string
  details?: string | null
}

export interface ExportCustomCsvByFormRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  contentId: number
  /**
   * Id of attached content form
   * @format int32
   */
  contentFormId: number
}

export interface FormAnswerCommentModel {
  email: string
  reply: string
}

export interface FormAnswerDataModel {
  /** @format int32 */
  contentId?: number | null
  sessionOwner?: string | null
  sessionTitle?: string | null
  /** @format int32 */
  formId: number
  formName?: string | null
  /** @format int32 */
  formQuestionId?: number | null
  formQuestion?: string | null
  formTabs?: string | null
  formAnswers: FormAnswerValueModel[]
  replies: FormAnswerCommentModel[]
  answeringUserEmail?: string | null
  genericId?: string | null
  /** @format date-time */
  formAnswerTime?: string | null
  /** @format date-time */
  formAnswerStatusTime?: string | null
  formAnswerStatusApprover?: string | null
  /**
   *
   *
   * 0 = Pending
   *
   * 1 = Pass
   *
   * 2 = Fail
   *
   * 3 = Empty
   *
   * 4 = ApprovedByAI
   *
   * 5 = RejectedByAI
   *
   * 6 = ApprovedByReviewer
   *
   * 7 = RejectedByReviewer
   */
  formAnswerStatus?: FormAnswerStatus
  pageUrl?: string | null
  /** @format int64 */
  pageSizeInBytes?: number | null
  /** @format float */
  pageSize?: number | null
  /** @format double */
  latitude?: number | null
  /** @format double */
  longitude?: number | null
  /** @maxLength 256 */
  externalData?: string | null
  isDeleted?: boolean | null
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Pass
 *
 * 2 = Fail
 *
 * 3 = Empty
 *
 * 4 = ApprovedByAI
 *
 * 5 = RejectedByAI
 *
 * 6 = ApprovedByReviewer
 *
 * 7 = RejectedByReviewer
 * @format int32
 */
export enum FormAnswerStatus {
  Pending = 0,
  Pass = 1,
  Fail = 2,
  Empty = 3,
  ApprovedByAI = 4,
  RejectedByAI = 5,
  ApprovedByReviewer = 6,
  RejectedByReviewer = 7,
}

export interface FormAnswerValueModel {
  /** @format int32 */
  id: number
  value: string
  /** @format int32 */
  pageId: number
}

/**
 *
 *
 * 0 = AllAnswers
 *
 * 1 = LatestPerPage
 *
 * 2 = LatestPerSession
 * @format int32
 */
export enum FormAnswersMode {
  AllAnswers = 0,
  LatestPerPage = 1,
  LatestPerSession = 2,
}

/**
 *
 *
 * 1 = AddCsvHeader
 *
 * 2 = ProduceFlatOutput
 * @format int32
 */
export enum GeneratedReportOutputFileOption {
  AddCsvHeader = 1,
  ProduceFlatOutput = 2,
}

/**
 *
 *
 * 1 = Email
 *
 * 2 = Ftp
 *
 * 3 = ReportOwner
 * @format int32
 */
export enum GeneratedReportReceiverType {
  Email = 1,
  Ftp = 2,
  ReportOwner = 3,
}

export interface GeneratedReportSetReceiverResponse {
  /** @format int32 */
  id: number
  /**
   *
   *
   * 1 = Email
   *
   * 2 = Ftp
   *
   * 3 = ReportOwner
   */
  type: GeneratedReportReceiverType
  address?: string | null
  isRevoked: boolean
}

export interface GeneratedReportSetReceiversResponse {
  receivers: GeneratedReportSetReceiverResponse[]
  /** @format int32 */
  totalCount: number
}

export interface GeneratedReportSetResponse {
  /** @format int32 */
  id: number
  name: string
  userName: string
  userEmail: string
  failReason: string
  /** @format date-time */
  requestedAt: string
  /** @format date-time */
  expiresAt: string
  /** @format date-time */
  finishedAt?: string | null
  cancellationRequested: boolean
  /**
   *
   *
   * 1 = Queued
   *
   * 2 = Active
   *
   * 3 = Finished
   *
   * 4 = Failed
   */
  status: ReportStatus
  /** @format int32 */
  completedReportParts: number
  /** @format int32 */
  totalReportParts: number
  reportOrigins: ReportTypes[]
  receivers: GeneratedReportSetReceiverResponse[]
}

export interface GetActivityReportRequest {
  /**
   * Id of the tenant for which report is generated
   *
   * If missing, then data for users tenant is returned.
   * @format int32
   */
  tenantId?: number | null
  exportPeriod: GetReportTimePeriod
}

export interface GetAnswersByContentReportRequest {
  /**
   * Unique id of the session within the system
   * @format int32
   */
  contentId: number
  /**
   *
   *
   * 0 = AllAnswers
   *
   * 1 = LatestPerPage
   *
   * 2 = LatestPerSession
   */
  latest: FormAnswersMode
  /**
   * Parameter for defining whether include deleted answers or no
   * @default false
   */
  includeDeletedAnswers: boolean
  /**
   * Time period for which the report is generated
   *
   * If missing, then data for all time is returned.
   */
  exportPeriod?: TimePeriod
  /**
   * List of forms ids for which the report is generated
   *
   * If missing, then data for all forms is returned.
   */
  formsIds?: number[] | null
  /**
   * If set to true, then unanswered questions will be included in the report.
   * @default false
   */
  includeUnansweredQuestions: boolean
}

export interface GetFormAnswersReportRequest {
  /**
   * Id of the tenant for which report is generated
   *
   * If missing, then data for users tenant is returned.
   * @format int32
   */
  tenantId?: number | null
  exportPeriod: GetReportTimePeriod
  /**
   * List of forms ids for which the report is generated
   *
   * If missing, then data for all forms is returned.
   */
  formsIds?: number[] | null
  /**
   * If set to true, then unanswered questions will be included in the report.
   * @default false
   */
  includeUnansweredQuestions: boolean
}

export interface GetReportTimePeriod {
  /** @format date-time */
  startDate: string
  /** @format date-time */
  endDate: string
}

export interface GetSessionsReportRequest {
  /**
   * Id of the tenant for which report is generated
   *
   * If missing, then data for users tenant is returned.
   * @format int32
   */
  tenantId?: number | null
  exportPeriod: GetReportTimePeriod
}

export interface PageResponse {
  /** @format int32 */
  pageId: number
  pageName: string
  /**
   *
   *
   * 0 = Unknown
   *
   * 1 = Video
   *
   * 2 = Text
   *
   * 3 = Pdf
   *
   * 4 = VideoByUrl
   *
   * 5 = CloudFile
   *
   * 6 = RecordedVideo
   *
   * 7 = Audio
   *
   * 8 = DrawingBoard
   *
   * 9 = Snapshot
   *
   * 10 = Image
   *
   * 11 = ConcatenatedVideo
   *
   * 12 = WebPage
   *
   * 13 = SpatialModel
   *
   * 14 = DocDocumentPage
   *
   * 15 = PptDocumentPage
   *
   * 16 = ExcelDocumentPage
   *
   * 17 = File
   *
   * 18 = StructureModel
   *
   * 19 = StructureModelPdf
   *
   * 20 = TwoDLineDrawing
   *
   * 21 = TwoDLineDrawingPdf
   *
   * 22 = AutodeskFile
   *
   * 23 = PointCloud
   *
   * 24 = BentleyAnalyticsReportPdf
   *
   * 101 = UnencodedVideo
   *
   * 102 = UnencodedRecordedVideo
   *
   * 103 = UnencodedConcatenatedVideo
   *
   * 104 = RecordedCloudFileVideo
   *
   * 105 = StreamVideo
   */
  pageContentType: ContentType
  /** @format date-time */
  pageCreatedOn: string
  pageThumbnailUrl: string
  /** @format int32 */
  contentId: number
  contentDescription: string
}

export interface PublishDashboardRequest {
  /** @format int32 */
  dashboardId: number
}

/**
 *
 *
 * 1 = CurrentUser
 *
 * 2 = Tenant
 *
 * 3 = TenantScheduled
 * @format int32
 */
export enum ReportCategory {
  CurrentUser = 1,
  Tenant = 2,
  TenantScheduled = 3,
}

/**
 *
 *
 * 1 = Queued
 *
 * 2 = Active
 *
 * 3 = Finished
 *
 * 4 = Failed
 * @format int32
 */
export enum ReportStatus {
  Queued = 1,
  Active = 2,
  Finished = 3,
  Failed = 4,
}

/**
 *
 *
 * 1 = Activity
 *
 * 2 = FormAnswers
 *
 * 3 = AllSessions
 *
 * 4 = LastActivity
 *
 * 5 = ActionsOverUsers
 *
 * 6 = CheckInCheckOut
 *
 * 7 = ScreeningLog
 *
 * 8 = FormAnswersWithUnansweredQuestions
 * @format int32
 */
export enum ReportTypes {
  Activity = 1,
  FormAnswers = 2,
  AllSessions = 3,
  LastActivity = 4,
  ActionsOverUsers = 5,
  CheckInCheckOut = 6,
  ScreeningLog = 7,
  FormAnswersWithUnansweredQuestions = 8,
}

/**
 *
 *
 * 1 = Profile
 *
 * 2 = Identity
 * @format int32
 */
export enum ReportUserAccessType {
  Profile = 1,
  Identity = 2,
}

/**
 *
 *
 * 0 = NotStarted
 *
 * 1 = ReadyForReview
 *
 * 2 = InReview
 *
 * 3 = SessionFeedbackSent
 *
 * 4 = Complete
 * @format int32
 */
export enum ReviewStatus {
  NotStarted = 0,
  ReadyForReview = 1,
  InReview = 2,
  SessionFeedbackSent = 3,
  Complete = 4,
}

/**
 *
 *
 * 1 = None
 *
 * 2 = Tenant
 *
 * 3 = UserProfile
 *
 * 4 = UserIdentity
 * @format int32
 */
export enum SecurityModelEnum {
  None = 1,
  Tenant = 2,
  UserProfile = 3,
  UserIdentity = 4,
}

export interface SessionNamingConventionAnswerModel {
  question: string
  answer: string
}

/**
 *
 *
 * 0 = NotStarted
 *
 * 1 = Live
 *
 * 2 = InProgress
 *
 * 3 = Published
 *
 * 4 = Shared
 *
 * 5 = CallEnded
 *
 * 6 = CheckedIn
 *
 * 7 = CheckedOut
 *
 * 8 = CopiedReview
 * @format int32
 */
export enum SessionStatus {
  NotStarted = 0,
  Live = 1,
  InProgress = 2,
  Published = 3,
  Shared = 4,
  CallEnded = 5,
  CheckedIn = 6,
  CheckedOut = 7,
  CopiedReview = 8,
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

export interface TenantContentDescriptionModel {
  description: string
  tenantName: string
}

export interface TenantContentsDashboardColumnResponse {
  /** @format int32 */
  id: number
  name: string
  /** @format int32 */
  order: number
  isCustom: boolean
}

export interface TenantContentsDashboardResponse {
  /** @format int32 */
  id: number
  name: string
  isDefault: boolean
  isOwner: boolean
  isPublished: boolean
  columns: TenantContentsDashboardColumnResponse[]
}

/**
 * Time period for which the report is generated
 *
 * If missing, then data for all time is returned.
 */
export interface TimePeriod {
  /**
   * Start date
   * @format date-time
   */
  startDate: string
  /**
   * End date
   * @format date-time
   */
  endDate: string
}

export interface UpdatePowerBIReportingProviderConfigurationRequest {
  /** @format uuid */
  azureTenantId: string
  /** @format uuid */
  azureClientId: string
  /**
   * @minLength 1
   * @maxLength 100
   */
  azureClientSecret: string
}

export interface UpdateReportTenantRequest {
  /** @minItems 1 */
  tenantRoles: string[]
}

export interface UpdateReportingProviderRequest {
  name: string
}

export interface UpdateReportingProviderUsersRequest {
  userIds: string[]
}

export interface UpdateTenantContentsDashboardColumnRequest {
  /** @format int32 */
  id?: number | null
  /** @minLength 1 */
  name: string
  /** @format int32 */
  order: number
  isCustom: boolean
}

export interface UpdateTenantContentsDashboardRequest {
  /** @format int32 */
  id: number
  /**
   * @minLength 1
   * @maxLength 256
   */
  name: string
  /** @minItems 1 */
  columns: UpdateTenantContentsDashboardColumnRequest[]
}

/**
 *
 *
 * 0 = VideoExported
 *
 * 1 = StartCall
 *
 * 2 = SessionCreated
 *
 * 3 = EnterSession
 *
 * 4 = AddAnnotation
 *
 * 5 = SessionDeleted
 *
 * 6 = SessionOwnerChanged
 *
 * 7 = ImageUploaded
 *
 * 8 = VideoUploaded
 *
 * 9 = FormStatusUpdated
 *
 * 10 = EndOfCall
 *
 * 11 = ExportPdf
 *
 * 12 = ExportImages
 *
 * 13 = InvitationSent
 *
 * 14 = InvitationAccepted
 *
 * 15 = SessionPublished
 *
 * 16 = SessionUnpublished
 *
 * 17 = SessionShared
 *
 * 18 = SessionSharingRevoked
 *
 * 19 = SessionCopied
 *
 * 20 = FormStatusUpdatedByAI
 *
 * 21 = SessionReadyForReview
 *
 * 22 = SessionReviewAccepted
 *
 * 23 = SessionFeedbackSent
 *
 * 24 = SessionReviewCompleted
 *
 * 25 = CheckIn
 *
 * 26 = CheckOut
 *
 * 27 = Confirm
 *
 * 28 = SessionReviewRevoked
 *
 * 29 = SessionReviewRejected
 *
 * 30 = SessionSharingRejected
 *
 * 31 = ReviewedSessionCopied
 *
 * 32 = SessionRestored
 *
 * 33 = ContentReactivated
 *
 * 34 = AttachedFormToContent
 *
 * 35 = DetachedFormFromContent
 *
 * 36 = ContentReadyForInContentReview
 *
 * 37 = InContentReviewAccepted
 *
 * 38 = InContentReviewFeedbackSent
 *
 * 39 = InContentReviewCompleted
 *
 * 40 = PageDeleted
 *
 * 41 = PageDeletedPermanently
 *
 * 42 = PageRestored
 *
 * 43 = AnswerDeleted
 *
 * 44 = ThreeHundredSixtyViewCreated
 *
 * 45 = ThreeDeeModelCreated
 *
 * 46 = PointCloudCreated
 *
 * 47 = CADCreated
 *
 * 48 = PageCreated
 *
 * 49 = PageAccessed
 *
 * 50 = TrainingMaterialsAccessed
 *
 * 51 = AnnotationUpdated
 *
 * 52 = AnnotationDeleted
 * @format int32
 */
export enum UserEventType {
  VideoExported = 0,
  StartCall = 1,
  SessionCreated = 2,
  EnterSession = 3,
  AddAnnotation = 4,
  SessionDeleted = 5,
  SessionOwnerChanged = 6,
  ImageUploaded = 7,
  VideoUploaded = 8,
  FormStatusUpdated = 9,
  EndOfCall = 10,
  ExportPdf = 11,
  ExportImages = 12,
  InvitationSent = 13,
  InvitationAccepted = 14,
  SessionPublished = 15,
  SessionUnpublished = 16,
  SessionShared = 17,
  SessionSharingRevoked = 18,
  SessionCopied = 19,
  FormStatusUpdatedByAI = 20,
  SessionReadyForReview = 21,
  SessionReviewAccepted = 22,
  SessionFeedbackSent = 23,
  SessionReviewCompleted = 24,
  CheckIn = 25,
  CheckOut = 26,
  Confirm = 27,
  SessionReviewRevoked = 28,
  SessionReviewRejected = 29,
  SessionSharingRejected = 30,
  ReviewedSessionCopied = 31,
  SessionRestored = 32,
  ContentReactivated = 33,
  AttachedFormToContent = 34,
  DetachedFormFromContent = 35,
  ContentReadyForInContentReview = 36,
  InContentReviewAccepted = 37,
  InContentReviewFeedbackSent = 38,
  InContentReviewCompleted = 39,
  PageDeleted = 40,
  PageDeletedPermanently = 41,
  PageRestored = 42,
  AnswerDeleted = 43,
  ThreeHundredSixtyViewCreated = 44,
  ThreeDeeModelCreated = 45,
  PointCloudCreated = 46,
  CADCreated = 47,
  PageCreated = 48,
  PageAccessed = 49,
  TrainingMaterialsAccessed = 50,
  AnnotationUpdated = 51,
  AnnotationDeleted = 52,
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Reports service api dev
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  dashboards = {
    /**
     * No description
     *
     * @tags Dashboards
     * @name GetTenantContentsDashboardsAsync
     * @request GET:/reporting-service/api/Dashboards
     * @secure
     */
    getTenantContentsDashboardsAsync: (params: RequestParams = {}) =>
      this.http.request<TenantContentsDashboardResponse[], any>({
        path: `/reporting-service/api/Dashboards`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name CreateTenantContentsDashboardAsync
     * @request POST:/reporting-service/api/Dashboards
     * @secure
     */
    createTenantContentsDashboardAsync: (data: CreateTenantContentsDashboardRequest, params: RequestParams = {}) =>
      this.http.request<TenantContentsDashboardResponse, void | ApiErrorResponse>({
        path: `/reporting-service/api/Dashboards`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name UpdateTenantContentsDashboardAsync
     * @request PUT:/reporting-service/api/Dashboards
     * @secure
     */
    updateTenantContentsDashboardAsync: (data: UpdateTenantContentsDashboardRequest, params: RequestParams = {}) =>
      this.http.request<TenantContentsDashboardResponse, ApiErrorResponse | void>({
        path: `/reporting-service/api/Dashboards`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name SetDefaultTenantContentsDashboardAsync
     * @request PUT:/reporting-service/api/Dashboards/setDefault/{dashboardId}
     * @secure
     */
    setDefaultTenantContentsDashboardAsync: (dashboardId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/reporting-service/api/Dashboards/setDefault/${dashboardId}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name ResetDefaultTenantContentsDashboardAsync
     * @request PUT:/reporting-service/api/Dashboards/resetDefault
     * @secure
     */
    resetDefaultTenantContentsDashboardAsync: (params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/reporting-service/api/Dashboards/resetDefault`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name DeleteTenantContentsDashboardAsync
     * @request DELETE:/reporting-service/api/Dashboards/{dashboardId}
     * @secure
     */
    deleteTenantContentsDashboardAsync: (dashboardId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/reporting-service/api/Dashboards/${dashboardId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name GetAvailableColumnsByTenantAsync
     * @request GET:/reporting-service/api/Dashboards/primaryColumns
     * @secure
     */
    getAvailableColumnsByTenantAsync: (params: RequestParams = {}) =>
      this.http.request<TenantContentsDashboardColumnResponse[], any>({
        path: `/reporting-service/api/Dashboards/primaryColumns`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name GetTenantContentsDashboardColumnsAsync
     * @request GET:/reporting-service/api/Dashboards/columns/{dashboardId}
     * @secure
     */
    getTenantContentsDashboardColumnsAsync: (dashboardId: number, params: RequestParams = {}) =>
      this.http.request<TenantContentsDashboardColumnResponse[], any>({
        path: `/reporting-service/api/Dashboards/columns/${dashboardId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name PublishDashboardAsync
     * @request POST:/reporting-service/api/Dashboards/publish
     * @secure
     */
    publishDashboardAsync: (data: PublishDashboardRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/reporting-service/api/Dashboards/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name UnpublishDashboardAsync
     * @request POST:/reporting-service/api/Dashboards/unpublish
     * @secure
     */
    unpublishDashboardAsync: (data: PublishDashboardRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/reporting-service/api/Dashboards/unpublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  powerBiReports = {
    /**
     * No description
     *
     * @tags PowerBIReports
     * @name GetPagedPowerBiReports
     * @request GET:/reporting-service/api/reports/powerBI
     * @secure
     */
    getPagedPowerBiReports: (
      query?: {
        /** @format int32 */
        Skip?: number
        /** @format int32 */
        Take?: number
        Search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name CreatePowerBiReport
     * @request POST:/reporting-service/api/reports/powerBI
     * @secure
     */
    createPowerBiReport: (data: CreatePowerBIReportRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/reports/powerBI`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name GetPowerBiReport
     * @request GET:/reporting-service/api/reports/powerBI/{id}
     * @secure
     */
    getPowerBiReport: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name DeletePowerBiReport
     * @request DELETE:/reporting-service/api/reports/powerBI/{id}
     * @secure
     */
    deletePowerBiReport: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name GetPowerBiReportEmbedData
     * @request GET:/reporting-service/api/reports/powerBI/{id}/embed
     * @secure
     */
    getPowerBiReportEmbedData: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI/${id}/embed`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name UpdateReportName
     * @request PUT:/reporting-service/api/reports/powerBI/{id}/name
     * @secure
     */
    updateReportName: (
      id: number,
      query: {
        /** @maxLength 100 */
        name: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI/${id}/name`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PowerBIReports
     * @name ValidatePowerBiReportConfiguration
     * @request GET:/reporting-service/api/reports/powerBI/validate-configuration
     * @secure
     */
    validatePowerBiReportConfiguration: (
      query: {
        /** @format uuid */
        WorkspaceId?: string
        /** @format uuid */
        DashboardId?: string
        /** @format int32 */
        ReportingProviderId?: number
        /**
         *
         *
         * 1 = None
         *
         * 2 = Tenant
         *
         * 3 = UserProfile
         *
         * 4 = UserIdentity
         */
        SecurityModel: SecurityModelEnum
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/powerBI/validate-configuration`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  reportDependentModules = {
    /**
     * No description
     *
     * @tags ReportDependentModules
     * @name GetByReport
     * @request GET:/reporting-service/api/report-dependent-modules
     * @secure
     */
    getByReport: (
      query: {
        /** @format int32 */
        ReportId: number
        /** @format int32 */
        PageNumber?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-dependent-modules`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportDependentModules
     * @name Create
     * @request POST:/reporting-service/api/report-dependent-modules/powerBI
     * @secure
     */
    create: (data: CreateReportDependentModuleRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/report-dependent-modules/powerBI`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportDependentModules
     * @name Delete
     * @request DELETE:/reporting-service/api/report-dependent-modules/{id}
     * @secure
     */
    delete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-dependent-modules/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  reportingProviders = {
    /**
     * No description
     *
     * @tags ReportingProviders
     * @name Get
     * @request GET:/reporting-service/api/reporting-providers/{id}
     * @secure
     */
    get: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name UpdateReportingProvider
     * @request PUT:/reporting-service/api/reporting-providers/{id}
     * @secure
     */
    updateReportingProvider: (id: number, data: UpdateReportingProviderRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/reporting-providers/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name GetProviderUsersIds
     * @request GET:/reporting-service/api/reporting-providers/{id}/users/ids
     * @secure
     */
    getProviderUsersIds: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/${id}/users/ids`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name AddReportingProviderUsers
     * @request PUT:/reporting-service/api/reporting-providers/{id}/users
     * @secure
     */
    addReportingProviderUsers: (id: number, data: UpdateReportingProviderUsersRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/reporting-providers/${id}/users`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name DisableReportingProvider
     * @request PUT:/reporting-service/api/reporting-providers/{id}/disable
     * @secure
     */
    disableReportingProvider: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/${id}/disable`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name EnableReportingProvider
     * @request PUT:/reporting-service/api/reporting-providers/{id}/enable
     * @secure
     */
    enableReportingProvider: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/${id}/enable`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name GetPagedPowerBiProviders
     * @request GET:/reporting-service/api/reporting-providers/powerBI
     * @secure
     */
    getPagedPowerBiProviders: (
      query?: {
        /** @format int32 */
        Skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        Take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/powerBI`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name CreatePowerBiReportingProvider
     * @request POST:/reporting-service/api/reporting-providers/powerBI
     * @secure
     */
    createPowerBiReportingProvider: (data: CreatePowerBIReportingProviderRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/reporting-providers/powerBI`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name GetPowerBiReportingProviderConfiguration
     * @request GET:/reporting-service/api/reporting-providers/powerBI/{id}/configuration
     * @secure
     */
    getPowerBiReportingProviderConfiguration: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/powerBI/${id}/configuration`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name UpdatePowerBiReportingProviderConfiguration
     * @request PUT:/reporting-service/api/reporting-providers/powerBI/{id}/configuration
     * @secure
     */
    updatePowerBiReportingProviderConfiguration: (
      id: number,
      data: UpdatePowerBIReportingProviderConfigurationRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/reporting-providers/powerBI/${id}/configuration`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name GetPowerBiProvidersForSearch
     * @request GET:/reporting-service/api/reporting-providers/powerBI/search
     * @secure
     */
    getPowerBiProvidersForSearch: (
      query?: {
        /** @default "" */
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/powerBI/search`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name DeletePowerBiReportingProvider
     * @request DELETE:/reporting-service/api/reporting-providers/powerBI/{id}
     * @secure
     */
    deletePowerBiReportingProvider: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/powerBI/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportingProviders
     * @name CheckPowerBiConnection
     * @request GET:/reporting-service/api/reporting-providers/powerBI/check-connection
     * @secure
     */
    checkPowerBiConnection: (
      query: {
        AzureTenantId: string
        AzureClientId: string
        AzureClientSecret: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reporting-providers/powerBI/check-connection`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  }
  reports = {
    /**
     * No description
     *
     * @tags Reports
     * @name GetAsync
     * @request GET:/reporting-service/api/reports/generated/{subdomain}
     * @secure
     */
    getAsync: (
      subdomain: string,
      query?: {
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         */
        Skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        Take?: number
        /**
         *
         *
         * 1 = CurrentUser
         *
         * 2 = Tenant
         *
         * 3 = TenantScheduled
         */
        Category?: ReportCategory
        /** @maxLength 50 */
        Name?: string
        /** @maxLength 50 */
        Receiver?: string
        /** @maxLength 50 */
        UserName?: string
        /** @format date-time */
        StartDate?: string
        /** @format date-time */
        EndDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GeneratedReportSetResponse[], any>({
        path: `/reporting-service/api/reports/generated/${subdomain}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetReceiversAsync
     * @request GET:/reporting-service/api/reports/generated/{reportId}/receivers
     * @secure
     */
    getReceiversAsync: (
      reportId: number,
      query?: {
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         * @default 25
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<GeneratedReportSetReceiversResponse, any>({
        path: `/reporting-service/api/reports/generated/${reportId}/receivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name CreateReportsBySubdomainAsync
     * @request POST:/reporting-service/api/reports/generated
     * @secure
     */
    createReportsBySubdomainAsync: (data: CreateReportsBySubdomainRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/reporting-service/api/reports/generated`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetGeneratedReportDownloadUrlAsync
     * @request GET:/reporting-service/api/reports/generated/{reportId}/download/url
     * @secure
     */
    getGeneratedReportDownloadUrlAsync: (reportId: number, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse>({
        path: `/reporting-service/api/reports/generated/${reportId}/download/url`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name DownloadGeneratedReportAsync
     * @request GET:/reporting-service/api/reports/{reportId}/download
     * @secure
     */
    downloadGeneratedReportAsync: (
      reportId: number,
      query: {
        token: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/${reportId}/download`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name RevokeReportAccessAsync
     * @request POST:/reporting-service/api/reports/generated/{reportId}/revoke/{receiverId}
     * @secure
     */
    revokeReportAccessAsync: (reportId: number, receiverId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/reporting-service/api/reports/generated/${reportId}/revoke/${receiverId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name RenewReportAccessAsync
     * @request POST:/reporting-service/api/reports/generated/{reportId}/renew/{receiverId}
     * @secure
     */
    renewReportAccessAsync: (reportId: number, receiverId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/reporting-service/api/reports/generated/${reportId}/renew/${receiverId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetAllTenantContentAsync
     * @request GET:/reporting-service/api/reports/contents/tenant
     * @secure
     */
    getAllTenantContentAsync: (
      query?: {
        SearchQuery?: string
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         */
        Skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        Take?: number
        /** @format int32 */
        DashboardId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AllSessionsPageResponse[], ApiErrorResponse>({
        path: `/reporting-service/api/reports/contents/tenant`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetAllDeletedTenantContentAsync
     * @request GET:/reporting-service/api/reports/contents/tenant/deleted
     * @secure
     */
    getAllDeletedTenantContentAsync: (
      query?: {
        SearchQuery?: string
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         */
        Skip?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        Take?: number
        /** @format int32 */
        DashboardId?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AllSessionsPageResponse[], ApiErrorResponse>({
        path: `/reporting-service/api/reports/contents/tenant/deleted`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ExportAllTenantContentToCsvAsync
     * @request GET:/reporting-service/api/reports/contents/export/csv
     * @secure
     */
    exportAllTenantContentToCsvAsync: (
      query?: {
        /** @format int32 */
        PageSize?: number
        /** @format int32 */
        DashboardId?: number
        SearchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/reporting-service/api/reports/contents/export/csv`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ExportCustomCsvByFormAsync
     * @request POST:/reporting-service/api/reports/contents/export/csv/custom
     * @secure
     */
    exportCustomCsvByFormAsync: (data: ExportCustomCsvByFormRequest, params: RequestParams = {}) =>
      this.http.request<string, ApiErrorResponse | void>({
        path: `/reporting-service/api/reports/contents/export/csv/custom`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetLastUpdateTimeAsync
     * @request GET:/reporting-service/api/reports/last-update-time
     * @secure
     */
    getLastUpdateTimeAsync: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/reports/last-update-time`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name FormAnswersReportAsync
     * @summary Request is used to receive a form answers report for specified session
     * @request POST:/reporting-service/api/reports/answers/bycontent
     * @secure
     */
    formAnswersReportAsync: (data: GetAnswersByContentReportRequest, params: RequestParams = {}) =>
      this.http.request<FormAnswerDataModel[], ApiErrorResponse | void>({
        path: `/reporting-service/api/reports/answers/bycontent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name FormAnswersReportAsync2
     * @summary Request is used to receive a form answers report for specified time period
     * @request POST:/reporting-service/api/reports/answers
     * @originalName formAnswersReportAsync
     * @duplicate
     * @secure
     */
    formAnswersReportAsync2: (data: GetFormAnswersReportRequest, params: RequestParams = {}) =>
      this.http.request<FormAnswerDataModel[], ApiErrorResponse | void>({
        path: `/reporting-service/api/reports/answers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ActivityReportAsync
     * @summary Request is used to receive a activity report for specified time period
     * @request POST:/reporting-service/api/reports/activity
     * @secure
     */
    activityReportAsync: (data: GetActivityReportRequest, params: RequestParams = {}) =>
      this.http.request<ActivityDataModel[], void>({
        path: `/reporting-service/api/reports/activity`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name AllSessionReportAsync
     * @summary Request is used to receive a session report for specified time period
     * @request POST:/reporting-service/api/reports/sessions
     * @secure
     */
    allSessionReportAsync: (data: GetSessionsReportRequest, params: RequestParams = {}) =>
      this.http.request<AllSessionsReportModel[], void>({
        path: `/reporting-service/api/reports/sessions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name GetAllAsync
     * @summary Returns list of pages for current user
     * @request GET:/reporting-service/api/reports/pages
     * @secure
     */
    getAllAsync: (
      query?: {
        /**
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @default 30
         */
        take?: number
        Column?: string
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        Order?: SortingOrder
        PageName?: string
        ContentTypes?: ContentType[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PageResponse[], any>({
        path: `/reporting-service/api/reports/pages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  reportTenants = {
    /**
     * No description
     *
     * @tags ReportTenants
     * @name GetByReport
     * @request GET:/reporting-service/api/report-tenants
     * @secure
     */
    getByReport: (
      query: {
        /** @format int32 */
        ReportId: number
        /** @format int32 */
        PageNumber?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-tenants`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTenants
     * @name Create
     * @request POST:/reporting-service/api/report-tenants
     * @secure
     */
    create: (data: CreateReportTenantRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/report-tenants`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTenants
     * @name GetTenantRoles
     * @request GET:/reporting-service/api/report-tenants/{id}/tenant-roles
     * @secure
     */
    getTenantRoles: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-tenants/${id}/tenant-roles`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTenants
     * @name Update
     * @request PUT:/reporting-service/api/report-tenants/{id}
     * @secure
     */
    update: (id: number, data: UpdateReportTenantRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/report-tenants/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportTenants
     * @name Delete
     * @request DELETE:/reporting-service/api/report-tenants/{id}
     * @secure
     */
    delete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-tenants/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  reportUsers = {
    /**
     * No description
     *
     * @tags ReportUsers
     * @name Get
     * @request GET:/reporting-service/api/report-users
     * @secure
     */
    get: (
      query: {
        /** @format int32 */
        ReportId: number
        /** @format int32 */
        PageNumber?: number
        /**
         * @format int32
         * @min 1
         * @max 100
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-users`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportUsers
     * @name Create
     * @request POST:/reporting-service/api/report-users
     * @secure
     */
    create: (data: CreateReportUserRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/reporting-service/api/report-users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ReportUsers
     * @name Delete
     * @request DELETE:/reporting-service/api/report-users/{id}
     * @secure
     */
    delete: (id: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/report-users/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  securityModels = {
    /**
     * No description
     *
     * @tags SecurityModels
     * @name Get
     * @request GET:/reporting-service/api/security-models
     * @secure
     */
    get: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/security-models`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  tabeebReportingMicroservice = {
    /**
     * No description
     *
     * @tags Tabeeb.ReportingMicroservice
     * @name MapTabeebHealthChecksB10
     * @request GET:/reporting-service/api/health/apim
     */
    mapTabeebHealthChecksB10: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/health/apim`,
        method: 'GET',
        ...params,
      }),
  }
  userClaimsEndpoints = {
    /**
     * No description
     *
     * @tags UserClaimsEndpoints
     * @name GetUserClaims
     * @request GET:/reporting-service/api/user-claims
     */
    getUserClaims: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/reporting-service/api/user-claims`,
        method: 'GET',
        ...params,
      }),
  }
}
